import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Table, Button } from 'reactstrap';
import * as timeCardEntryActions from '../../actions/timeCardEntryActions';
import * as timeCardActions from '../../actions/timeCardActions';
import TimeCardEntry from './TimeCardEntry';
import TimeCardEntryInlineForm from './TimeCardEntryInlineForm';
import { toast } from 'react-toastify';
import { hasRole } from '../../services/authService';
import moment from 'moment';
import { loadLimitedUsers } from '../../actions/userActions';

class TimeCardEntryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      currentTimeCard: props.currentTimeCard,
      timeCardEntries: props.timeCardEntries.sort(function (a, b) {
        return new Date(a.timeIn) - new Date(b.timeIn);
      }),
    };
  }

  componentWillMount() {
    this.props.actions.loadLimitedUsers();
    let currentTimeCard = Number.parseInt(this.props.currentTimeCard.id, 10);
    this.props.actions.loadTimeCardEntriesByCardId(currentTimeCard);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timeCardEntries) {
      if (this.props.timeCardEntries !== nextProps.timeCardEntries) {
        this.setState({
          timeCardEntries: nextProps.timeCardEntries.sort(function (a, b) {
            return new Date(a.timeIn) - new Date(b.timeIn);
          }),
        });
      }
    }
  }

  redirectToTimeCards = () => {
    if (!hasRole('ROLE_MANAGER')) this.props.history.push('/time-cards');
    else this.props.history.push('/time-admin');
  };

  redirectToAddEntryPage = () => {
    this.props.history.push('/time-card-entry');
  };

  submitTimeCard = () => {
    const { currentTimeCard } = this.state;
    currentTimeCard.isSubmitted = true;
    currentTimeCard.submitDate = moment().format('YYYY-MM-DDTHH:mm');
    currentTimeCard.isApproved = false;
    currentTimeCard.approvalDate = null;
    this.setState({ saving: true });
    this.props.actions
      .saveTimeCard(currentTimeCard)
      .then(() => {
        toast.success('Time card submitted.');
        this.setState({ saving: false });
        this.redirectToTimeCards();
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  rejectTimeCard = () => {
    const { currentTimeCard } = this.state;
    currentTimeCard.isSubmitted = false;
    currentTimeCard.submitDate = null;
    currentTimeCard.isApproved = false;
    currentTimeCard.approvalDate = null;
    this.setState({ saving: true });
    this.props.actions
      .saveTimeCard(currentTimeCard)
      .then(() => {
        toast.success('Time card successfully rejected.');
        this.setState({ saving: false });
        this.redirectToTimeCards();
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  approveTimeCard = () => {
    const { currentTimeCard } = this.state;
    currentTimeCard.isApproved = true;
    currentTimeCard.approvalDate = moment().format('YYYY-MM-DDTHH:mm:ss');
    this.setState({ saving: true });
    this.props.actions
      .saveTimeCard(currentTimeCard)
      .then(() => {
        toast.success('Time card approved.');
        this.setState({ saving: false });
        this.redirectToTimeCards();
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  saveEntry = (timeCardEntry) => {
    this.setState({ saving: true });
    this.props.actions
      .saveTimeCardEntry(timeCardEntry)
      .then(() => {
        toast.success('Entry saved.');
        this.setState({ saving: false });
      })
      .catch((error) => {
        toast.error(error.message);
        this.setState({ saving: false });
      });
  };

  render() {
    const {
      currentTimeCard,
      totalHours,
      workHours,
      holidayHours,
      paidTimeOff,
      users,
    } = this.props;
    const { timeCardEntries } = this.state;
    const cardUser = users.filter((u) => u.id === currentTimeCard.userId)[0];
    return (
      <div>
        <Row>
          <Col md={12}>
            <h1 className="text-center mt-4">
              Time Card # {currentTimeCard.id}
            </h1>
            {hasRole('ROLE_MANAGER') && (
              <h2 className="text-center mt-2 mb-4">{cardUser.initials}</h2>
            )}
          </Col>
        </Row>
        <Row>
          <TimeCardEntryInlineForm
            saveTimeEntry={this.saveEntry}
            cardId={Number(currentTimeCard.id)}
            userId={currentTimeCard.userId}
          />
        </Row>
        <Row>
          <Col md={12}>
            {timeCardEntries.length > 0 ? (
              <Table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Entry Code</th>
                    <th>Time In</th>
                    <th>Time Out</th>
                    <th>Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {timeCardEntries.map((entry) => (
                    <TimeCardEntry
                      key={entry.id}
                      cardEntry={{ ...entry }}
                      user={users.filter((u) => u.id === entry.userId)}
                    />
                  ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Work Hours</td>
                    <td>
                      {typeof workHours !== 'undefined'
                        ? Number(workHours).toFixed(2)
                        : Number(0.0).toFixed(2)}
                    </td>
                  </tr>
                  {/*
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Sick Hours</td>
                  <td>{typeof sickHours !== "undefined" ? Number(sickHours).toFixed(2) : Number(0.0).toFixed(2)}</td>
                </tr>
                */}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Holiday Hours</td>
                    <td>
                      {typeof holidayHours !== 'undefined'
                        ? Number(holidayHours).toFixed(2)
                        : Number(0.0).toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Other Paid Hours</td>
                    <td>
                      {typeof paidTimeOff !== 'undefined'
                        ? Number(paidTimeOff).toFixed(2)
                        : Number(0.0).toFixed(2)}
                    </td>
                  </tr>
                  {/*
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Other Unpaid Hours</td>
                  <td>{typeof unpaidOffHours !== "undefined" ? Number(unpaidOffHours).toFixed(2) : Number(0.0).toFixed(2)}</td>
                </tr>
                */}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total Hours</td>
                    <td>
                      {typeof totalHours !== 'undefined'
                        ? Number(totalHours).toFixed(2)
                        : Number(0.0).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <Col md={12}>
                <h4 className="my-4 ">No entries found</h4>
              </Col>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-2">
            {hasRole('ROLE_CONTRACTOR') && (
              <Button
                color="primary"
                className="mx-3"
                onClick={() => {
                  this.submitTimeCard();
                }}
              >
                Submit
              </Button>
            )}
            {hasRole('ROLE_MANAGER') && (
              <Button
                color="danger"
                className="mx-3"
                onClick={() => {
                  this.rejectTimeCard();
                }}
              >
                Reject
              </Button>
            )}
            {hasRole('ROLE_MANAGER') && (
              <Button
                color="success"
                className="mr-3"
                onClick={() => {
                  this.approveTimeCard();
                }}
              >
                Approve
              </Button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

TimeCardEntryPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function getTotalCardHours(entries) {
  let tHours = 0.0;
  entries.forEach(function (entry) {
    tHours = tHours + Number(entry.entryHours);
  });
  return tHours;
}

function getHoursByType(entries, entryType) {
  let hours = 0.0;
  let list = entries.filter((e) => e.entryType === entryType);
  list.forEach(function (entry) {
    hours = hours + Number(entry.entryHours);
  });
  return hours;
}

function getTimeCardById(cards, id) {
  const card = cards.filter((card) => card.id === id);
  if (card) return card[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const cardId = Number.parseInt(id, 10);

  let currentTimeCard = {
    id: '',
    payPeriodWeekId: '',
    userId: '',
    isSubmitted: '',
    submitDate: '',
    isApproved: '',
    approvalDate: '',
  };

  if (cardId && state.timeCards.length > 0) {
    currentTimeCard = getTimeCardById(state.timeCards, cardId);
  }

  if (state.timeCardEntries.length > 0) {
    var totalHours = getTotalCardHours(state.timeCardEntries);
    var workHours = getHoursByType(state.timeCardEntries, 'Work');
    var sickHours = getHoursByType(state.timeCardEntries, 'Sick');
    var holidayHours = getHoursByType(state.timeCardEntries, 'Holiday');
    var unpaidOffHours = getHoursByType(
      state.timeCardEntries,
      'Unpaid Time Off'
    );
    var paidTimeOff = getHoursByType(state.timeCardEntries, 'Unpaid Time Off');
  }

  return {
    currentTimeCard: currentTimeCard,
    timeCardEntries: state.timeCardEntries,
    totalHours: totalHours,
    workHours: workHours,
    sickHours: sickHours,
    holidayHours: holidayHours,
    unpaidOffHours: unpaidOffHours,
    paidTimeOff: paidTimeOff,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...timeCardEntryActions, ...timeCardActions, loadLimitedUsers },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TimeCardEntryPage)
);



// WEBPACK FOOTER //
// ./src/components/timecard/TimeCardEntryPage.js